import { useLocalization } from 'localization'
import { message } from 'antd'
import { useMutation } from 'react-query'
import { getSignedUrl, uploadBySignedUrl } from './services'
import { IGetSignedUrlParams } from './models'
import { ResponseErrorType } from 'types/custom'

export const useS3Upload = () => {
	const { t } = useLocalization()

	return useMutation(
		async (params: IGetSignedUrlParams) => {
			const s3Object = await getSignedUrl(params)
			await uploadBySignedUrl({
				...s3Object,
				file: params.file,
			})
			return s3Object.Key
		},
		{
			onError: (error: ResponseErrorType) => {
				if (error?.response?.status !== 401) {
					message.error(t('errors.S3_UPLOAD'))
				}
			},
		}
	)
}
